import type React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorBoundary } from '@/components/errorBoundary';
import { ImportHistoryContent } from './ImportHistoryContent';

type ImportHistoryProps = {
    branchId: string;
};

/**
 * The in-shell page's **Import history** under Upload: the branch's imports,
 * newest first, with no undo (bos-app#198). A section of its own: it reads
 * its own history, and a render failure stays inside it, so Upload keeps
 * working. Another branch starts it afresh.
 */
export const ImportHistory: React.FC<ImportHistoryProps> = ({ branchId }) => {
    const { t } = useTranslation('pages');

    return (
        <ErrorBoundary
            data-testid="branch-import-history-boundary"
            fallbackMessage={t('catalogImport.branchImport.history.crash')}
            id="branch-import-history-boundary"
            resetKeys={[branchId]}
            retryLabel={t('catalogImport.branchImport.history.retry')}
            title={t('catalogImport.branchImport.history.loadError')}
        >
            <ImportHistoryContent branchId={branchId} />
        </ErrorBoundary>
    );
};
